import React from "react";
import { Icon } from "@material-ui/core";
import styled from "styled-components";

import { Thumbnail } from "js/react/views/AddSlide/Panes/Components/ThumbnailGrid";
import { ThumbnailCard } from "js/react/views/AddSlide/Panes/Components/ThumbnailCard";
import { _ } from "js/vendor";

const ThumbnailCardBar = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: 9px 10px 10px 10px;

    > div {
        line-height: 150%;
        display: flex;
        align-items: center;
        font-size: 14px;
        letter-spacing: 0px;
        font-weight: 600;
        color: #222;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        text-align: left;
        flex-grow: 2;
        text-transform: none;
        margin: 0px;
    }
`;

const ColorChits = styled.div`
    position: absolute;
    bottom: 10px;
    display: flex;
    justify-content: flex-start;
    padding: 0px 10px;
    width: 100%;
    gap: 4px;
`;

const ColorChit = styled.div`
    border-radius: 50%;
    width: 14px;
    height: 14px;
`;

const HiddenThemeIcon = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 30px;
    height: 30px;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
        color: white;
        font-size: 20px;
    }
`;

export const ThemeCardThumbnail = React.forwardRef(function ThemeCardThumbnail(
    { theme, name, onClick, onDoubleClick, onMouseEnter, onMouseLeave, menu, isRollover, onCloseMenu, showBar, selected, url, backgroundColor, isDowngraded, colors, isHiddenTheme },
    ref
) {
    const menuOverlay = isRollover && menu && (
        <>
            {React.isValidElement(menu)
                ? React.cloneElement(menu, { handleCloseMenu: onCloseMenu })
                : menu}
        </>
    );

    return (
        <ThumbnailCard
            data-item-id={theme.id}
            onClick={onClick}
            onDoubleClick={onDoubleClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            ref={ref}
            menuOverlay={menuOverlay}
            selected={selected}
            barContent={showBar ? <ThumbnailCardBar><div>{name}</div></ThumbnailCardBar> : null}
            barVariant="custom"
        >
            <Thumbnail
                url={url}
                style={{
                    background: backgroundColor,
                    ...(isDowngraded ? { opacity: 0.5, cursor: "not-allowed" } : {})
                }}
                imageStyle={isHiddenTheme ? { filter: "brightness(0.7)" } : {}}
                showSpinner={false}
                readOnly
            >
                {isHiddenTheme && <HiddenThemeIcon><Icon>visibility_off</Icon></HiddenThemeIcon>}
                {theme.get("isBuiltIn") && (
                    <ColorChits>
                        {colors.map(color => <ColorChit key={_.uniqueId()} style={{ background: color }} />)}
                    </ColorChits>
                )}
            </Thumbnail>
        </ThumbnailCard>
    );
});
